import { taskOutputSchema } from "./task/output.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/referenceVideo.ts
const referenceVideoModelSchema = z.string().min(1);
const referenceVideoCreateRequestSchema = z.object({
	model: referenceVideoModelSchema,
	mode: z.enum(["basic", "professional"]).default("basic"),
	audioLanguage: z.enum([
		"none",
		"chinese",
		"english",
		"japanese",
		"korean"
	]).nullable().default(null),
	prompt: z.string().nullable().default(null),
	referenceImageMediaIds: z.array(z.string().min(1)).default([]),
	referenceVideoMediaIds: z.array(z.string().min(1)).default([]),
	referenceAudioMediaIds: z.array(z.string().min(1)).default([]),
	generateAudio: z.boolean().default(true),
	duration: z.int().default(5),
	inputVideoDurations: z.array(z.number().positive()).default([])
}).superRefine((value, ctx) => {
	if (!(value.referenceImageMediaIds.length > 0 || value.referenceVideoMediaIds.length > 0)) ctx.addIssue({
		code: "custom",
		message: "At least one reference image or reference video is required",
		path: []
	});
});
const referenceVideoContract = oc.prefix("/reference-video").tag("Reference Video").router({ create: oc.route({
	summary: "Create a multimodal reference video task",
	method: "POST",
	path: "/create",
	outputStructure: "detailed"
}).input(referenceVideoCreateRequestSchema).output(z.object({
	status: z.literal(201),
	body: taskOutputSchema
})).errors({
	UNAUTHORIZED: {
		status: 401,
		message: "Authentication required"
	},
	CREATION_FAILED: {
		status: 500,
		message: "Task creation failed"
	}
}) });
//#endregion
export { referenceVideoContract, referenceVideoCreateRequestSchema, referenceVideoModelSchema };
